// extracted by mini-css-extract-plugin
export default {"Loader":"App_Loader__9yOHF"};